import React from 'react';
import PropTypes from 'prop-types';
import { isString, isObject } from 'lodash';
import clxBind from 'classnames/bind';
import Spin from '../Spin';
import Icon from '../Icon';
import Link from '../Link';
import styles from './styles.module.scss';

const clx = clxBind.bind(styles);

export default class Button extends React.Component {
  static propTypes = {
    type: PropTypes.oneOf(['button', 'submit', 'link', 'radio', 'check']),
    mode: PropTypes.oneOf(['default', 'primary', 'success', 'warning', 'danger']),
    inline: PropTypes.bool,
    size: PropTypes.oneOf(['xs', 's', 'm', 'l', 'xl']),
    border: PropTypes.oneOf(['transparent', 'none']),
    width: PropTypes.oneOf(['available']),
    disabled: PropTypes.bool,
    checked: PropTypes.bool,
    submitting: PropTypes.bool,
    spinColor: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.any,
    icon: PropTypes.node,
    className: PropTypes.string,
    children: PropTypes.node,
  };

  static defaultProps = {
    type: 'button',
    mode: 'default',
    inline: false,
    size: 'm',
    border: undefined,
    width: undefined,
    disabled: false,
    checked: false,
    submitting: false,
    spinColor: undefined,
    onChange: undefined,
    value: '',
    icon: null,
    className: undefined,
    children: null,
  };

  render() {
    const {
      type,
      mode,
      size,
      inline,
      border,
      width,
      disabled,
      checked,
      submitting,
      spinColor,
      onChange,
      value,
      icon,
      className,
      children,
      ...props
    } = this.props;

    let iconElement;
    let childElement;

    const buttonClasses = clx(
      'button',
      {
        [`size-${size}`]: size,
        [`mode-${mode}`]: mode,
        [`border-${border}`]: border,
        [`width-${width}`]: width,
        checked,
        disabled,
        inline,
      },
      className
    );

    if (type !== 'submit') {
      if (icon && isString(icon)) {
        iconElement = <Icon icon={icon} className={styles['icon']} />;
      } else if (icon) {
        iconElement = <div className={styles['icon']}>{icon}</div>;
      }
    } else {
      iconElement = submitting ? (
        <div className={styles['spin']}>
          <Spin thickness={1} color={spinColor} />
        </div>
      ) : (
        undefined
      );
    }

    if (!children || isObject(children)) {
      childElement = children;
    } else {
      childElement = <span className={styles['content']}>{children}</span>;
    }

    let inputType = type;

    if (type === 'check') {
      inputType = 'checkbox';
    }

    switch (type) {
      case 'link':
        return (
          <Link className={buttonClasses} disabled={disabled} {...props}>
            {iconElement}
            {childElement}
          </Link>
        );
      case 'radio':
      case 'check':
        return (
          <label className={buttonClasses} htmlFor={props.id}>
            <input
              type={inputType}
              className={styles['input']}
              disabled={disabled}
              checked={checked}
              onChange={onChange}
              value={value}
              {...props}
            />
            <span>
              {iconElement}
              {childElement}
            </span>
          </label>
        );
      default:
        return (
          <button type={inputType} disabled={disabled} className={buttonClasses} {...props}>
            {iconElement}
            {childElement}
          </button>
        );
    }
  }
}
